export const convertMetricDimensionPropertiesToStrings = metricProps => {
  const stringProps = Object.entries(metricProps).reduce((acc, [key, value]) => {
    if (['string', 'number', 'boolean'].includes(typeof value)) {
      acc[key] = `${value}`;
    }
    return acc;
  }, {});
  return stringProps;
};